import { useContext } from 'react';
import { AppHeaderContext } from './app-header-context';

export const useAppHeader = () => useContext(AppHeaderContext);
